module.exports = __webpack_public_path__ + "img/c2.7cdd88c3.png";